export default __webpack_public_path__ + "static/media/kr.27834060.png";